import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pharmacies',
    templateUrl: './pharmacies.component.html',
    styleUrls: ['./pharmacies.component.css'],
    standalone: false
})
export class PharmaciesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
